/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Openpositions_Placeholder1Inputs */

const en_company_registration_openpositions_placeholder1 = /** @type {(inputs: Company_Registration_Openpositions_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What positions do you want to fill?`)
};

const de_company_registration_openpositions_placeholder1 = /** @type {(inputs: Company_Registration_Openpositions_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Stellen möchten Sie besetzen?`)
};

/**
* | output |
* | --- |
* | "What positions do you want to fill?" |
*
* @param {Company_Registration_Openpositions_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_openpositions_placeholder1 = /** @type {((inputs?: Company_Registration_Openpositions_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Openpositions_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_openpositions_placeholder1(inputs)
	return en_company_registration_openpositions_placeholder1(inputs)
});
export { company_registration_openpositions_placeholder1 as "company_registration_openPositions_placeholder" }